module.exports = require("@seddi/three/examples/jsm/shaders/CopyShader.js");